import { Listbox } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import classNames from 'classnames'
import { useEffect, useState } from 'react'

export default function FilterSelect({
  defaultFilter,
  onFilterChange,
}: {
  defaultFilter: `Leads` | `Qualified Leads` | `Appointments Scheduled` | `Patients`
  onFilterChange: (filter: `Leads` | `Qualified Leads` | `Appointments Scheduled` | `Patients`) => void
}) {
  const [filter, setFilter] = useState<`Leads` | `Qualified Leads` | `Appointments Scheduled` | `Patients`>(
    defaultFilter,
  )
  const options = [`Leads`, `Qualified Leads`, `Appointments Scheduled`, `Patients`]

  useEffect(() => {
    onFilterChange(filter)
  }, [filter])
  return (
    <Listbox as="div" value={filter} onChange={setFilter} className="relative">
      {({ open }) => (
        <>
          <Listbox.Button className="text-default btn btn-sm btn-tertiary flex gap-2 px-4 py-2">
            <p className="text-ui-xs">{filter}</p>
            <ChevronDownIcon
              className={classNames(`h-4 w-4 fill-current stroke-current text-default`, {
                [`rotate-180 transform`]: open,
              })}
            />
          </Listbox.Button>
          <Listbox.Options
            modal={false}
            className="absolute right-0 top-9 z-50 mt-1 h-max w-max overflow-auto rounded-lg border border-default bg-surface-raised shadow-elevation-4 ring-0 focus:outline-none"
          >
            {options.map((option) => (
              <Listbox.Option
                key={option}
                value={option}
                className="cursor-pointer p-4 text-body-sm capitalize text-default hover:bg-(--menu-hover)"
              >
                {option}
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </>
      )}
    </Listbox>
  )
}
